// Packages
// import type { Model as Products } from '@nuinalp/cms-sdk-js/types/resources/products';
import { defineStore } from 'pinia';
import type { IPayloadCMSProducts } from '~/server/api/products/[slug]/types';

// Utils
export const useProductStore = defineStore('product', () => {
  const product = ref<IPayloadCMSProducts['docs'][number] | undefined>(undefined);

  function set(new_product: IPayloadCMSProducts['docs'][number]) {
    product.value = new_product
  }

  function reset() {
    product.value = undefined
  }

  return {
    product,
    set,
    reset
  }
});
